import type { ReactNode } from 'react';
import { motion } from 'framer-motion';
import './draft-app-toast.css';

const toastMotion = {
  initial: { opacity: 0, scale: 0.72, y: -12 },
  animate: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.88, y: -8 },
  transition: { type: 'spring' as const, stiffness: 480, damping: 24, mass: 0.65 },
};

type DraftAppToastProps = {
  message: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
};

/** Draft 스타일 앱 토스트 — createPortal + AnimatePresence 안에서 사용 */
export function DraftAppToast({ message, actionLabel, onAction }: DraftAppToastProps) {
  const hasAction = Boolean(actionLabel && onAction);

  return (
    <motion.div
      role="status"
      aria-live="polite"
      {...toastMotion}
      className={`draft-app-toast fixed top-24 sm:top-20 left-1/2 -translate-x-1/2 z-[10000] origin-top${
        hasAction ? ' draft-app-toast--with-action' : ''
      }`}
    >
      <span className="draft-app-toast__message">{message}</span>
      {hasAction ? (
        <button type="button" className="draft-app-toast__action" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </motion.div>
  );
}
